import { useLanguage } from "../i18n/LanguageContext";
import { Reveal } from "../components/Motion";
import { PageHeader, CtaBand } from "../components/Detail";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

export default function Faq() {
  const { t } = useLanguage();
  const f = t.faq;
  return (
    <main id="main-content">
      <PageHeader overline={f.pageOverline} title={f.pageTitle} sub={f.pageSub} overlineTestId="faq-page-overline" />
      <div className="mx-auto max-w-3xl px-5 py-14 sm:px-8 sm:py-16">
        <Reveal>
          <Accordion type="single" collapsible className="rounded-3xl border border-warmline bg-white px-6 sm:px-8" data-testid="faq-accordion">
            {f.items.map((item, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-warmline">
                <AccordionTrigger
                  data-testid={`faq-question-${i}`}
                  className="py-5 text-left font-display text-base font-semibold tracking-tight text-petrol hover:text-teal-dark hover:no-underline sm:text-lg"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent data-testid={`faq-answer-${i}`} className="pb-5 text-sm leading-relaxed text-slate2 sm:text-base">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
        <div className="mt-12">
          <CtaBand testId="faq-cta-band" ctaTestId="faq-whatsapp-cta" />
        </div>
      </div>
    </main>
  );
}
